/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lockedOverlay[_ngcontent-%COMP%]{border-radius:16px;height:100%;background:#222;opacity:.75}.fa-lock[_ngcontent-%COMP%], .lockedOverlay[_ngcontent-%COMP%]{width:100%;position:absolute}.fa-lock[_ngcontent-%COMP%]{z-index:2;top:45%;text-align:center;color:#fff;font-size:2rem}.bigImage[_ngcontent-%COMP%]{z-index:1;width:300px;border-radius:16px}"];
export { styles as styles };
//# sourceMappingURL=private-class-banner-image.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-left-header-banner/private-class-banner-image/private-class-banner-image.component.scss.shim.ngstyle.js
// module id = 1416
// module chunks = 26 27 28